export function formatDateToGreek(isoString) {
    const monthsGreek = [
        "Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαϊ", "Ιουν",
        "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"
    ];

    const date = new Date(isoString);

    const day = date.getUTCDate();
    const month = monthsGreek[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
}

export default formatDateToGreek